/* Event-ticket pages (product.type == "Event Ticket" renders the BinderPOS
   CalendarV2 widget via snippets/events.liquid; this file loads only there).
   Job 1: strip every other section so the event stands alone.
   Job 2: inject the dark exor-red / exor-yellow neon skin over the widget.
   The widget hydrates AFTER DOMContentLoaded and injects its own inline
   <style> blocks with !important (light-gray back pill, #f5f5f5 title band),
   so every override here carries !important and an extra .xg-eventpage hook
   on <html> for higher specificity than the widget's #id .class rules. */
window.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("main .shopify-section").forEach(function (e) {
    if (!e.id.includes("productDescription")) e.remove();
  });

  document.documentElement.classList.add("xg-eventpage");
  var css = [
    /* The stage: near-black canvas with the neon corner glows. */
    '.xg-eventpage main .collectionTemplate {',
    '  position: relative;',
    '  background:',
    '    radial-gradient(760px 320px at 6% -10%, rgba(214,44,40,0.18), transparent 62%),',
    '    radial-gradient(700px 320px at 96% 108%, rgba(255,216,0,0.09), transparent 60%),',
    '    linear-gradient(180deg, #0b0e10, #0e1114 55%, #0a0d0f) !important;',
    '  border-radius: 18px;',
    '  margin: 14px 0 34px;',
    '  overflow: hidden;',
    '}',
    '.xg-eventpage main .collectionTemplate::before {',
    '  content: ""; position: absolute; top: 0; left: 0; right: 0; height: 3px; z-index: 2;',
    '  background: linear-gradient(90deg, #d62c28, #ff8a2e 42%, #ffd800 72%, transparent);',
    '}',
    '.xg-eventpage #event-calendar-app, .xg-eventpage #event-calendar-app .cleanslate { color: #dfe6ea; }',

    /* Back to events: dark pill instead of the widget\'s light-gray one. */
    '.xg-eventpage #event-calendar-app .single-event__back {',
    '  background: rgba(255,255,255,0.07) !important;',
    '  border: 1px solid rgba(255,255,255,0.16) !important;',
    '  color: #e8edef !important;',
    '  border-radius: 999px !important;',
    '  padding: 8px 16px !important;',
    '  transition: border-color 130ms ease, color 130ms ease;',
    '}',
    '.xg-eventpage #event-calendar-app .single-event__back:hover {',
    '  background: rgba(214,44,40,0.18) !important;',
    '  border-color: rgba(214,44,40,0.6) !important;',
    '  color: #fff !important;',
    '}',
    '.xg-eventpage #event-calendar-app .single-event__back svg { fill: #e8edef !important; }',
    '.xg-eventpage #event-calendar-app .single-event__body { border-color: rgba(255,255,255,0.08) !important; }',

    /* Title band: was a flat #f5f5f5 sheet - now a dark panel with a neon name. */
    '.xg-eventpage #event-calendar-app .calendar-event-details__title {',
    '  background: linear-gradient(180deg, #15191c, #101417) !important;',
    '  border: 1px solid rgba(255,255,255,0.09) !important;',
    '  border-radius: 16px !important;',
    '  padding: 22px 24px !important;',
    '}',
    '.xg-eventpage #event-calendar-app .calendar-event-details__name {',
    '  font-family: var(--xg-font-display, "Oswald", "Arial Narrow", sans-serif) !important;',
    '  font-size: clamp(24px, 3.2vw, 34px) !important;',
    '  font-weight: 600 !important;',
    '  text-transform: uppercase;',
    '  letter-spacing: 0.02em;',
    '  color: #fff !important;',
    '  text-shadow: 0 2px 14px rgba(0,0,0,0.55), 0 0 26px rgba(214,44,40,0.3);',
    '}',
    '.xg-eventpage #event-calendar-app .calendar-event-details__location,',
    '.xg-eventpage #event-calendar-app .calendar-event-details__location--physical {',
    '  color: #ffd84d !important;',
    '}',
    '.xg-eventpage #event-calendar-app .calendar-event-details__date.eca-without-image,',
    '.xg-eventpage #event-calendar-app .calendar-event-details__date.eca-without-image span { color: #cfd8dd !important; }',
    '.xg-eventpage #event-calendar-app .calendar-event-details__date.eca-without-image svg { fill: #cfd8dd !important; }',

    /* Purchase Tickets: the site\'s red action button with a neon lift. */
    '.xg-eventpage #event-calendar-app .rsvp-button {',
    '  background: linear-gradient(180deg, #e6392f, #c22320) !important;',
    '  border: 1px solid rgba(255,120,110,0.5) !important;',
    '  border-radius: 999px !important;',
    '  box-shadow: inset 0 1px 0 rgba(255,255,255,0.22), 0 6px 18px rgba(214,44,40,0.35) !important;',
    '  transition: filter 130ms ease, transform 130ms ease;',
    '}',
    '.xg-eventpage #event-calendar-app .rsvp-button:hover { filter: brightness(1.08); transform: translateY(-1px); }',
    '.xg-eventpage #event-calendar-app .rsvp-button.rsvp-button--sold-out {',
    '  background: rgba(255,255,255,0.1) !important;',
    '  border-color: rgba(255,255,255,0.18) !important;',
    '  box-shadow: none !important;',
    '  filter: none !important;',
    '}',
    '.xg-eventpage #event-calendar-app .calendar-event-details__buy-tickets-text,',
    '.xg-eventpage #event-calendar-app .calendar-board-event__buy-tickets-text { color: #fff !important; font-weight: 700 !important; }',

    /* Banner art: rounded, framed, gently lifted. */
    '.xg-eventpage #event-calendar-app .calendar-event-details__image {',
    '  border-radius: 16px !important;',
    '  border: 1px solid rgba(255,255,255,0.1) !important;',
    '  box-shadow: 0 18px 50px rgba(0,0,0,0.5) !important;',
    '}',

    /* Description / prizes: dark card, readable type, yellow links. */
    '.xg-eventpage #event-calendar-app .calendar-event-details__description {',
    '  background: #14181b !important;',
    '  border: 1px solid rgba(255,255,255,0.09) !important;',
    '  border-radius: 16px !important;',
    '  padding: 22px 24px !important;',
    '  color: #c7d1d7 !important;',
    '}',
    '.xg-eventpage #event-calendar-app .calendar-event-details__description p,',
    '.xg-eventpage #event-calendar-app .calendar-event-details__description li,',
    '.xg-eventpage #event-calendar-app .calendar-event-details__long-description,',
    '.xg-eventpage #event-calendar-app .calendar-event-details__prize-structure { color: #c7d1d7 !important; }',
    '.xg-eventpage #event-calendar-app .calendar-event-details__description h1,',
    '.xg-eventpage #event-calendar-app .calendar-event-details__description h2,',
    '.xg-eventpage #event-calendar-app .calendar-event-details__description h3,',
    '.xg-eventpage #event-calendar-app .calendar-event-details__description h4,',
    '.xg-eventpage #event-calendar-app .calendar-event-details__description strong { color: #fff !important; }',
    '.xg-eventpage #event-calendar-app .calendar-event-details__description a { color: #ffd84d !important; }',
    '.xg-eventpage #event-calendar-app .calendar-event-details__description hr { border-color: rgba(255,255,255,0.12) !important; }',
    '.xg-eventpage #event-calendar-app .calendar-event-partipants h3 {',
    '  color: #ffd84d !important;',
    '  text-shadow: 0 0 14px rgba(255,216,0,0.35);',
    '  font-family: var(--xg-font-display, "Oswald", "Arial Narrow", sans-serif) !important;',
    '  text-transform: uppercase;',
    '  letter-spacing: 0.05em;',
    '}',
    '.xg-eventpage #event-calendar-app .calendar-event-partipants p, .xg-eventpage #event-calendar-app .noRegistered { color: #c7d1d7 !important; }',

    /* Type / game chips keep their inline colors but read as neat pills. */
    '.xg-eventpage #event-calendar-app .calendar-event-details__filter {',
    '  border-radius: 999px !important;',
    '  padding: 5px 12px !important;',
    '  font-size: 12px !important;',
    '  font-weight: 700 !important;',
    '  letter-spacing: 0.06em;',
    '  text-transform: uppercase;',
    '  color: #fff !important;',
    '}',

    /* Bottom bar: add-to-calendar as a dark pill, sharing icons visible. */
    '.xg-eventpage #event-calendar-app .event-subcribe-to-calendar {',
    '  background: rgba(255,255,255,0.08) !important;',
    '  border: 1px solid rgba(255,255,255,0.16) !important;',
    '  border-radius: 999px !important;',
    '}',
    '.xg-eventpage #event-calendar-app .event-subcribe-to-calendar:hover { border-color: rgba(255,216,0,0.55) !important; }',
    '.xg-eventpage #event-calendar-app .sharing__icon svg { fill: #8fa0a8 !important; }',
    '.xg-eventpage #event-calendar-app .sharing__icon:hover svg { fill: #ffd84d !important; }',
    '.xg-eventpage #event-calendar-app .calendar-event-details__map iframe { border-radius: 12px; }',

    /* The strip of other events under the detail (board cards) goes dark too. */
    '.xg-eventpage #event-calendar-app .calendar-board-event, .xg-eventpage #event-calendar-app [class*="calendar-board-event__container"] {',
    '  background: #14181b !important;',
    '  border: 1px solid rgba(255,255,255,0.09) !important;',
    '  border-radius: 14px !important;',
    '  color: #dfe6ea !important;',
    '}',
    '.xg-eventpage #event-calendar-app [class*="calendar-board-event__"] { color: #dfe6ea; }',
    '.xg-eventpage #event-calendar-app .event-summary { color: #cfd8dd !important; }',
    '.xg-eventpage #event-calendar-app .subcribe-to-calendar__inverse {',
    '  background: rgba(255,255,255,0.07) !important;',
    '  border: 1px solid rgba(255,255,255,0.16) !important;',
    '  border-radius: 999px !important;',
    '  color: #e8edef !important;',
    '}',
    '.xg-eventpage #event-calendar-app .calendar-list-view__navigate-button { background: rgba(255,255,255,0.07) !important; border-radius: 50% !important; }',
    '.xg-eventpage #event-calendar-app .calendar-list-view__navigate-button svg { fill: #e8edef !important; }',

    '@media (max-width: 767px) {',
    '  .xg-eventpage main .collectionTemplate { border-radius: 0; margin: 0 0 22px; }',
    '  .xg-eventpage #event-calendar-app .calendar-event-details__title { padding: 16px 16px !important; }',
    '  .xg-eventpage #event-calendar-app .calendar-event-details__description { padding: 16px 16px !important; }',
    '}'
  ].join('\n');
  var tag = document.createElement("style");
  tag.textContent = css;
  document.head.appendChild(tag);
});
